var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.mode === 'textarea')?_c('textarea',{attrs:{"id":_vm.name,"name":_vm.name}},[_vm._v(_vm._s(_vm.values ? _vm.values : ''))]):_c('input',{attrs:{"id":_vm.name,"name":_vm.name},domProps:{"value":_vm.values}})}
var staticRenderFns = []

export { render, staticRenderFns }